var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.fileOnFlow.detalle.ejecucion
    ? _c("div", { attrs: { id: "management" } }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-1 position-relative text-center" }, [
            _vm.fileOnFlowAttachments.length
              ? _c(
                  "div",
                  { staticClass: "container-attachment" },
                  [
                    _vm._l(_vm.fileOnFlowAttachments, function(attachment) {
                      return _c(
                        "div",
                        {
                          key: attachment.url,
                          staticClass: "box-attachments",
                          on: {
                            click: function($event) {
                              return _vm.selectFile(attachment)
                            }
                          }
                        },
                        [
                          !attachment.esInicial
                            ? _c(
                                "b-button",
                                {
                                  staticClass:
                                    "btn-icon mt-2 text-center shadow",
                                  attrs: { variant: "outline-primary" }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { icon: "FileIcon" }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          attachment.esInicial
                            ? _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "ripple",
                                      rawName: "v-ripple.400",
                                      value: "rgba(113, 102, 240, 0.15)",
                                      expression: "'rgba(113, 102, 240, 0.15)'",
                                      modifiers: { "400": true }
                                    }
                                  ],
                                  staticClass:
                                    "btn-icon mt-2 text-center shadow",
                                  attrs: { variant: "outline-warning" }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { icon: "FileTextIcon" }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    _c(
                      "div",
                      {
                        staticClass:
                          "position-fixed manage-comments text-left m-auto"
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "h6",
                              {
                                staticClass: "my-2",
                                staticStyle: { "font-size": "12px" }
                              },
                              [_vm._v(" comentarios ")]
                            ),
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal",
                                    value: "modal-comments",
                                    expression: "'modal-comments'"
                                  },
                                  {
                                    name: "ripple",
                                    rawName: "v-ripple.400",
                                    value: "rgba(113, 102, 240, 0.15)",
                                    expression: "'rgba(113, 102, 240, 0.15)'",
                                    modifiers: { "400": true }
                                  }
                                ],
                                staticClass:
                                  "btn-icon rounded-circle shadow-lg",
                                attrs: {
                                  id: "toggle-btn",
                                  variant: "outline-primary"
                                }
                              },
                              [
                                _c("feather-icon", {
                                  attrs: { icon: "MessageCircleIcon" }
                                })
                              ],
                              1
                            ),
                            _vm.fileOnFlow.detalle &&
                            _vm.fileOnFlow.detalle.ejecucion
                              ? _c("Comments", {
                                  attrs: {
                                    comments:
                                      _vm.fileOnFlow.detalle.ejecucion
                                        .comentarios
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  2
                )
              : _vm._e()
          ]),
          _c("div", { staticClass: "col-7" }, [
            _vm.selectedFile
              ? _c(
                  "a",
                  { attrs: { href: _vm.filePdf.url, target: "_blank" } },
                  [
                    _c(
                      "h5",
                      {
                        staticClass:
                          "text-primary underline d-inline-block mr-2"
                      },
                      [
                        _vm._v(
                          " * Visualizando documento seleccionado " +
                            _vm._s(_vm.filePdf.nombreCompleto) +
                            " * "
                        )
                      ]
                    ),
                    _c("feather-icon", { attrs: { icon: "ExternalLinkIcon" } })
                  ],
                  1
                )
              : _vm._e(),
            !_vm.isImage
              ? _c("div", { staticClass: "d-flex" }, [
                  _vm.selectedFile
                    ? _c(
                        "div",
                        {
                          ref: "pdfViewport",
                          staticClass: "shadow container-pdf"
                        },
                        _vm._l(_vm.numPages, function(i) {
                          return _c("pdf", {
                            key: i,
                            staticClass: "mt-2",
                            attrs: { page: i, src: _vm.selectedFile }
                          })
                        }),
                        1
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ]),
          _c(
            "div",
            { staticClass: "col-4" },
            [
              _c(
                "b-card",
                { staticClass: "shadow border-0 pt-0" },
                [
                  _c("div", { staticClass: "bg-white pb-2" }, [
                    _vm.fileOnFlow.detalle && _vm.fileOnFlow.detalle.ejecucion
                      ? _c("h5", { staticClass: "card-title mb-0" }, [
                          _vm._v(
                            " Expediente # " +
                              _vm._s(_vm.fileOnFlow.detalle.ejecucion.numero) +
                              " en el " +
                              _vm._s(_vm.fileOnFlow.detalle.ejecucion.nombre) +
                              " "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _c("b-card-body", { staticClass: "p-0" }, [
                    _c(
                      "div",
                      { staticClass: "mt-2 shadow" },
                      [
                        _vm.fileOnFlow.detalle && _vm.fileOnFlow.detalle.pasos
                          ? _c("Steps", {
                              attrs: {
                                steps: _vm.fileOnFlow.detalle.pasos,
                                ejecucion: _vm.fileOnFlow.detalle.ejecucion
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm.fileOnFlow.detalle
                      ? _c(
                          "div",
                          { staticClass: "mt-5 container-actions" },
                          [
                            _c("ManageDocument", {
                              attrs: {
                                title: "Reenviar",
                                action: "resend",
                                color: "outline-info",
                                "step-id": _vm.step
                              }
                            }),
                            _c("ManageDocument", {
                              attrs: {
                                title: "Devolver",
                                action: "return",
                                color: "outline-warning",
                                "step-id": _vm.step
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }